<template>
<!-- 省市区 -->
    <div class="modal" v-show="visible">
        <div class="modal-bg"></div>
        <div class="modal-content" ref="monthPie" :style="type != 'normal' ? 'width:340px;' : widthStyle">
            <div class="modal-header">
                <span class="fl">{{title}}</span>
            </div>
            <div class="modal-warp">
                {{content}}
            </div>
            <div class="modal-footer ac">
                <button class="btn btn-blue" @click="handleAction('yes')">{{btnText}}</button>
                <button class="btn btn-none" @click="handleAction('no')">{{cancelText}}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data (){
        return {
            visible:false,
            title:'提示',
            content:'',
            btnText:'确定',
            cancelText:'取消',
            type:'',
            promiseStatus:null,
        }
    },
    methods: {
        confirm() {
            let that = this;
            that.visible = true;
            return new Promise(function (resolve, reject) {
                that.promiseStatus = {resolve, reject};
            });
        },
        handleAction (action){
            this.visible=false;
            if(action=='yes'){
                this.promiseStatus && this.promiseStatus.resolve();
            }else{
                this.promiseStatus && this.promiseStatus.reject();
            }
        }
    }
}
</script>
<style lang="" scoped>
    .modal{display:flex;align-items:center;justify-content:center;position:fixed;top:0;left:0;width:100%;height:100%;z-index:999;}
    .modal-bg{width:100%;height:100%;background:rgba(0,0,0,.5);}
    .modal-content{position:absolute;background:#fff;border-radius:4px;}
    .modal-header{height:45px;padding:0 16px;line-height:44px;border-bottom:1px solid #ddd;}
    .modal-header .close{width:20px;height:20px;margin:11px 0;}
    .modal-header .close img{margin:4px;}
    .modal-warp{padding:24px;}
    .modal-footer{padding:8px 0 24px;}
    .modal-footer .btn{width:92px;margin:0 8px;}
</style>


// WEBPACK FOOTER //
// src/components/confirm/confirm.vue